<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head"><a id="page_5">C<span class="small">ONTENTS</span></a></p><a id="page_5">
</a><p class="TOC"><a id="page_5"></a><a href="#/Preface">Preface</a></p>
<p class="TOC"><a href="#/Ack">Acknowledgements</a></p>
<p class="TOC"><a href="#/Intro">Introduction</a></p>
<p class="TOC1"><a href="#/Chapter01">Roosevelt Relents</a></p>
<p class="TOC"><a href="#/Chapter02">Why Oswego?</a></p>
<p class="TOC"><span href="#/Chapter03" title="Link target outside of Sample">Friends at the Fence</span></p>
<p class="TOC"><span href="#/Chapter04" title="Link target outside of Sample">The Door Begins to Open</span></p>
<p class="TOC"><span href="#/Chapter05" title="Link target outside of Sample">The “Dowager Queens” and the Power of the Press</span></p>
<p class="TOC"><span href="#/Chapter06" title="Link target outside of Sample">The Home Dairy Cafeteria</span></p>
<p class="TOC"><span href="#/Chapter07" title="Link target outside of Sample">We’re Just Like the Pilgrims</span></p>
<p class="TOC"><span href="#/Chapter08" title="Link target outside of Sample">Preparation for Life</span></p>
<p class="TOC"><span href="#/Chapter09" title="Link target outside of Sample">Adult Education</span></p>
<p class="TOC"><span href="#/Chapter10" title="Link target outside of Sample">Higher Education</span></p>
<p class="TOC"><span href="#/Chapter11" title="Link target outside of Sample">The International Scout Troops</span></p>
<p class="TOC"><span href="#/Chapter12" title="Link target outside of Sample">The Loudest Voices</span></p>
<p class="TOC"><span href="#/Chapter13" title="Link target outside of Sample">Six Months in Limbo</span></p>
<p class="TOC"><span href="#/Chapter14" title="Link target outside of Sample">The Golden Cage and Those Who Remained</span></p>
<p class="TOC"><span href="#/Chapter15" title="Link target outside of Sample">A Tale of Three Tailors</span></p>
<p class="TOC1"><span href="#/Epilog" title="Link target outside of Sample">Epilogue</span></p>
<p class="TOCI"><span href="#/Epilog#sec1" title="Link target outside of Sample">The Republican and the Liberal</span></p>
<p class="TOCI"><span href="#/Epilog#sec2" title="Link target outside of Sample">An Encore for an Operetta Lost, Then Found</span></p>
<p class="TOC"><a id="page_6"></a><span href="#/Conclusion" title="Link target outside of Sample">Conclusion</span></p>
<p class="TOC"><span href="#/Notes" title="Link target outside of Sample">Notes</span></p>
<p class="TOC"><span href="#/Bib" title="Link target outside of Sample">Selected Bibliography</span></p>
<p class="TOC"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?696656e1